import { SistemAlertsDataDTO } from '../dto/SistemAlertsDTO';
import { SistemAlertsData } from '../../domain/SystemAlerts';

export class SistemAlertsMapper {
  static toDomain(dto: SistemAlertsDataDTO): SistemAlertsData {
    return new SistemAlertsData(
      dto.license_plate,
      dto.provider_name,
      dto.actual_location,
      dto.capacity,
      dto.coverage,
      dto.dlz,
      dto.transport_id
    );
  }

  static toDomainList(dtos: SistemAlertsDataDTO[]): SistemAlertsData[] {
    return dtos.map(this.toDomain);
  }
}
